import React from 'react';
import {
  Alert,
  Avatar,
  Box,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  List,
  ListItemAvatar,
  ListItemButton,
  ListItemText,
  Tooltip,
} from '@mui/material';
import { CheckCircle, Person } from '@mui/icons-material';
import CircularProgress from '@mui/material/CircularProgress';
import { ApiService } from 'app/servicesTwo/ApiService';

const DialogSelecionarMenor = ({
  showDialogSelecionarMenor,
  setShowDialogSelecionarMenor,
  menoresVinculados,
  isLoadingMenorId,
  setIsLoadingMenorId,
  usuarioLogado,
  initialValuesIJM,
  formikRef,
  setMenorSelecionado,
  setUser,
  setResponsavelEncontrado,
  setIsUserVerified,
  setShowIJMForm,
  setShowIJMFormMenor,
  setPrecisaResponsavel,
  setEtapaAtual,
  setMesmoCelular,
  setMesmoEmail,
  setDocumentoExistente,
  setDocumentoTutela,
  setDocumentoRemovido,
  calcularIdade,
  toast,
  cadastrarNovoMenor,
  menoresJaMatriculadosIds = [],
}) => (
  <Dialog
    open={showDialogSelecionarMenor}
    onClose={() => setShowDialogSelecionarMenor(false)}
    maxWidth='md'
    fullWidth
  >
    <DialogTitle>Selecione o menor para matricular</DialogTitle>
    <DialogContent>
      {menoresVinculados.length === 0 ? (
        <Alert severity='info'>Você ainda não tem menores cadastrados.</Alert>
      ) : (
        <List>
          {menoresVinculados.map((menor) => (
            <ListItemButton
              key={menor.pessoa_id}
              disabled={isLoadingMenorId !== null}
              onClick={async () => {
                setIsLoadingMenorId(menor.pessoa_id);
                try {
                  const response = await ApiService.get(
                    `/menores/pessoa/${menor.pessoa_id}`
                  );
                  const menorData = response.data;

                  setMenorSelecionado(menorData);
                  setUser(menorData.pessoa);
                  setResponsavelEncontrado(usuarioLogado);

                  // Resetar estado de documento do menor anterior
                  setDocumentoTutela(null);
                  setDocumentoRemovido(false);
                  // Buscar documento de tutela existente
                  ApiService.get(`/menores/documentos/${menor.pessoa_id}`)
                    .then((docRes) => {
                      const tutela = docRes.data?.find((d) => d.tipo === 'tutela');
                      setDocumentoExistente(tutela || null);
                    })
                    .catch(() => setDocumentoExistente(null));
                  setIsUserVerified(true);
                  setShowIJMForm(true);
                  setShowIJMFormMenor(true);
                  setPrecisaResponsavel(true);
                  setShowDialogSelecionarMenor(false);
                  setEtapaAtual('formulario');

                  const responsavelData = usuarioLogado;
                  const menorPessoa = menorData.pessoa;

                  const enderecoIgual =
                    menorPessoa.endereco === responsavelData.endereco &&
                    menorPessoa.numero === responsavelData.numero &&
                    menorPessoa.CEP === responsavelData.CEP &&
                    menorPessoa.cidade === responsavelData.cidade &&
                    menorPessoa.uf === responsavelData.uf;

                  // Detectar se o menor usa contato do responsável
                  const celularMenorNum = menorPessoa.celular?.replace(/\D/g, '');
                  const usaCelularResponsavel = !celularMenorNum || celularMenorNum === '05511';
                  const usaEmailResponsavel = !menorPessoa.email;

                  setMesmoCelular(usaCelularResponsavel);
                  setMesmoEmail(usaEmailResponsavel);

                  setTimeout(() => {
                    if (formikRef.current) {
                      formikRef.current.setValues({
                        ...initialValuesIJM,
                        nome: menorPessoa.nome || '',
                        data_nascimento: menorPessoa.data_nascimento || '',
                        cpf: menorPessoa.cpf || '',
                        rg_menor: menorPessoa.rg || '',
                        email: usaEmailResponsavel
                          ? responsavelData.email || ''
                          : menorPessoa.email || '',
                        email_confirmacao: usaEmailResponsavel
                          ? responsavelData.email || ''
                          : menorPessoa.email || '',
                        celular: usaCelularResponsavel
                          ? responsavelData.celular || '05511'
                          : menorPessoa.celular || '05511',
                        celular_confirmacao: usaCelularResponsavel
                          ? responsavelData.celular || ''
                          : menorPessoa.celular || '',
                        telefone: menorPessoa.telefone || '05511',
                        endereco: enderecoIgual
                          ? responsavelData.endereco
                          : menorPessoa.endereco || '',
                        numero: enderecoIgual
                          ? responsavelData.numero
                          : menorPessoa.numero || '',
                        complemento: enderecoIgual
                          ? responsavelData.complemento
                          : menorPessoa.complemento || '',
                        bairro: enderecoIgual
                          ? responsavelData.bairro
                          : menorPessoa.bairro || '',
                        cidade: enderecoIgual
                          ? responsavelData.cidade
                          : menorPessoa.cidade || '',
                        uf: enderecoIgual
                          ? responsavelData.uf
                          : menorPessoa.uf || '',
                        CEP: enderecoIgual
                          ? responsavelData.CEP
                          : menorPessoa.CEP || '',
                        pais: enderecoIgual
                          ? responsavelData.pais
                          : menorPessoa.pais || 'BR',
                        grau_parentesco: menorData.grau_parentesco || '',
                        deficiencias: menorData.deficiencias?.tipos || [],
                        outra_deficiencia:
                          menorData.deficiencias?.outra || '',
                        alergias: menorData.alergias?.tipos || [],
                        outra_alergia: menorData.alergias?.outra || '',
                        problemas_saude:
                          menorData.problemas_saude?.tipos || [],
                        outro_problema_saude:
                          menorData.problemas_saude?.outro || '',
                        transtornos: menorData.transtornos?.tipos || [],
                        outro_transtorno: menorData.transtornos?.outro || '',
                        medicacao_continua: menorData.medicacao_continua || false,
                        medicamentos: menorData.medicamentos || '',
                        contato_emergencia_1_nome:
                          menorData.contatos_emergencia?.[0]?.nome || '',
                        contato_emergencia_1_parentesco:
                          menorData.contatos_emergencia?.[0]?.parentesco || '',
                        contato_emergencia_1_celular:
                          menorData.contatos_emergencia?.[0]?.celular || '',
                        contato_emergencia_2_nome:
                          menorData.contatos_emergencia?.[1]?.nome || '',
                        contato_emergencia_2_parentesco:
                          menorData.contatos_emergencia?.[1]?.parentesco || '',
                        contato_emergencia_2_celular:
                          menorData.contatos_emergencia?.[1]?.celular || '',
                        contato_emergencia_3_nome:
                          menorData.contatos_emergencia?.[2]?.nome || '',
                        contato_emergencia_3_parentesco:
                          menorData.contatos_emergencia?.[2]?.parentesco || '',
                        contato_emergencia_3_celular:
                          menorData.contatos_emergencia?.[2]?.celular || '',
                        pode_ir_sozinho: menorData.pode_ir_sozinho || false,
                      });
                      formikRef.current.validateForm();
                    }
                  }, 100);
                  toast(
                    'success',
                    'Dados do menor carregados. Você pode atualizá-los.'
                  );
                } catch (error) {
                  toast('error', 'Erro ao carregar dados do menor');
                  console.error(error);
                } finally {
                  setIsLoadingMenorId(null);
                }
              }}
              sx={{
                mb: 1,
                borderRadius: 1,
                border: 1,
                borderColor: 'divider',
                '&:hover': {
                  borderColor: 'primary.main',
                  bgcolor: 'primary.50',
                },
              }}
            >
              <ListItemAvatar>
                {isLoadingMenorId === menor.pessoa_id ? (
                  <CircularProgress size={24} />
                ) : (
                  <Avatar>
                    <Person />
                  </Avatar>
                )}
              </ListItemAvatar>
              <ListItemText
                primary={
                  <Box display='flex' alignItems='center' gap={1}>
                    {menor.pessoa.nome}
                    {menoresJaMatriculadosIds.includes(menor.menor_id) && (
                      <Tooltip title='Você já selecionou este menor nesta visita — pode ter sido matriculado agora ou já estar matriculado de antes'>
                        <Chip
                          icon={<CheckCircle />}
                          label='Já verificado nesta sessão'
                          size='small'
                          color='success'
                          variant='outlined'
                        />
                      </Tooltip>
                    )}
                  </Box>
                }
                secondary={`CPF: ${
                  menor.pessoa.cpf || 'Não informado'
                } | Idade: ${calcularIdade(
                  menor.pessoa.data_nascimento
                )} anos`}
              />
            </ListItemButton>
          ))}
        </List>
      )}
    </DialogContent>
    <DialogActions>
      <Button
        onClick={() => {
          setShowDialogSelecionarMenor(false);
          cadastrarNovoMenor();
        }}
      >
        Cadastrar novo menor
      </Button>
      <Button onClick={() => setShowDialogSelecionarMenor(false)}>
        Cancelar
      </Button>
    </DialogActions>
  </Dialog>
);

export default DialogSelecionarMenor;
